import React, { useEffect, useState } from "react";
import { Calendar } from "antd";
import moment from "moment";
import '../../../Assets/Css/TaskCalendar.scss';
import TaskIcon from '../../../Assets/Images/Task/taskicon';
import Select from 'react-select';
import { customStyle } from '../../../Components/Style';
import TaskBoardIcon from '../../../Assets/Images/Task/taskboard';
import TaskCalendarIcon from '../../../Assets/Images/Task/taskcalendar';
import { useLocation, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { getTasks, updateTask } from "../../../Services/Task/action";
import { getTime } from "../../../Lib/utils";
import Skeleton from "react-loading-skeleton";
import "../../../Assets/Css/Holiday.scss";

const EmpTaskCalendar = (props) => {

    const initialState = {
        status: { value: 'Hide Completed Task', label: 'Hide Completed Task' },
        project: null,
    };
    const [inData, setInData] = useState([]);
    const [activeButton, setActiveButton] = useState('');
    const [clientData, setClientData] = useState(initialState);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const Status = [
        { value: 'Hide Completed Task', label: 'Hide Completed Task' },
        { value: 'All', label: 'All' },
        { value: 'Incomplete', label: 'Incomplete' },
        { value: 'To-Do', label: 'To Do' },
        { value: 'Doing', label: 'Doing' },
        { value: 'Completed', label: 'Completed' },
    ];

    const Project = [
        { value: 'Hrms_CloseDigit', label: 'Hrms_CloseDigit' },
        { value: 'CD-Admin', label: 'CD-Admin' },
        { value: 'Project 3', label: 'Project 3' },
    ];



    let path = '/task/emptask/add';
    const ClickAddTask = () => {
        navigate(path);
    };

    useEffect(() => {
        fetchData();
    }, [location.search]);

    const fetchData = async () => {
        try {
            await props?.getTasks();
        } catch (error) {
            console.error('Error fetching tasks in task calendar:', error);
        }
    };

    useEffect(() => {
        if (props?.task?.length) {
            updateCalendarData(props?.task)
        }
    }, [props?.task]);

    const updateCalendarData = (data) => {
        setLoading(true);

        const mappedData = data?.map((item) => {
            const taskTimers = item?.taskTimerMap?.[0];
            const allTimers = item?.taskTimerMap;
            const actionHistory =
                typeof taskTimers?.action_history === "string"
                    ? JSON.parse(taskTimers?.action_history)
                    : taskTimers?.action_history || [];

            const { time } = getTime(
                taskTimers?.start_time,
                taskTimers?.stop_time,
                actionHistory
            );

            let totalElapsedTime = 0;
            allTimers?.forEach((timer) => {
                if (timer?.duration) {
                    const [hh, mm, ss] = timer?.duration
                        ?.split(/[hms\s]+/)
                        .filter(Boolean)
                        .map(Number);
                    totalElapsedTime += hh * 3600 + mm * 60 + ss;
                }
            });

            const totalH = Math.floor(totalElapsedTime / 3600);
            const totalM = Math.floor((totalElapsedTime % 3600) / 60);
            const totalS = totalElapsedTime % 60;
            const totalHoursLogged = `${totalH}h ${totalM}m ${totalS}s`;

            return {
                id: item?.id,
                date: moment(item?.start_date, "YYYY-MM-DD").format("DD-MM-YYYY"),
                memo: item?.title,
                allData: {
                    ...item,
                    taskTimers,
                    totalHoursLogged,
                    time,
                },
            };
        });

        setInData(mappedData);
        setLoading(false);
    };

    useEffect(() => {
        if (location.pathname == '/task/emptask') {
            const path = location.pathname.slice(6);
            setActiveButton(path);
        } else if (location.pathname == '/task/emptaskboard') {
            const path = location.pathname.slice(6);
            setActiveButton(path);
        } else if (location.pathname == '/task/emptaskcalendar') {
            const path = location.pathname.slice(6);
            setActiveButton(path);
        }
    }, []);

    const applyFilters = ({ status, project, search }) => {
        setLoading(true);
        const filtered = props?.task?.filter((task) => {
            let matchesSearch = true;
            let matchesProject = true;
            let matchesStatus = true;

            const taskTitle = task?.title?.toLowerCase() || '';

            if (status && status?.value !== "All") {
                if (status?.value == "Hide Completed Task") {
                    matchesStatus = task?.status?.toLowerCase() !== "completed";
                } else {
                    matchesStatus = task?.status?.toLowerCase() == status?.value?.toLowerCase();
                }
            }
            if (project) {
                matchesProject = task?.project?.name?.toLowerCase() == project?.value?.toLowerCase();
            }
            if (search) {
                matchesSearch = taskTitle.includes(search.toLowerCase());
            }
            return matchesStatus && matchesProject && matchesSearch;
        });
        updateCalendarData(filtered);
        setLoading(false);
    };
    useEffect(() => {
        if (props?.task?.length) {
            applyFilters({ status: clientData.status });
        }
    }, [props.task]);

    const searchFiled = (e) => {
        const { name, value } = e.target;
        setSearchTerm(value);
        setClientData((preVal) => ({
            ...preVal,
            [name]: value,
        }));

        applyFilters({ status: clientData?.status, project: clientData?.project, search: value });
    };

    const handleClear = () => {
        const defaultStatus = { value: 'Hide Completed Task', label: 'Hide Completed Task' };
        setClientData({
            status: defaultStatus,
            searchTerm: "",
            employeename: "",
        });
        setSearchTerm("");
        updateCalendarData(props?.task);
        applyFilters({ status: defaultStatus });
    };

    const clickButton = (buttonId, route) => {
        setActiveButton(buttonId);
        navigate(route);
    };

    const shouldShowClearButton = () => {
        const hasSearchTerm = searchTerm;
        const hasProjectFilter = clientData?.project;
        const hasNonDefaultStatus = clientData?.status && clientData?.status?.value !== 'Hide Completed Task';

        return hasSearchTerm || hasProjectFilter || hasNonDefaultStatus;
    };

    const dateCellRender = (value) => {
        const date = value.format("DD-MM-YYYY");
        const tasks = inData.filter((entry) => entry.date === date);

        if (tasks.length > 0) {
            return (
                <div className="holiday-marker">
                    {tasks.map((task) => (
                        <div
                            key={task.id}
                            className="holiday-occasion"
                            style={{
                                cursor: "pointer",
                                color: "#5757fe",
                                fontSize: "12px",
                            }}
                            onClick={() => handleNavigate(task)}
                        >
                            {task.memo}
                        </div>
                    ))}
                </div>
            );
        }

        return null;
    };

    const handleNavigate = (event) => {
        navigate(`/task/emptask/view/${event?.id}`)
    }

    return (
        <div className="task-calendar">
            <div className="taskcalendar-main">
                <div className="page-title" style={{ padding: '0px', margin: '0px' }}>
                    <h4>
                        {
                            props.loading ? (
                                <Skeleton className="rounded-2" width={200} height={40} />
                            ) : (
                                "Task Calendar"
                            )
                        }
                    </h4>
                    {
                        props.loading ? (
                            <Skeleton className="badge rounded-pill" width={100} height={40} />
                        ) : (
                            <button
                                className="custom-taskcalendar-btn"
                                disabled={props.loading}
                                onClick={ClickAddTask}
                            >Add Task
                            </button>
                        )
                    }
                </div>
                <div className="row">

                    <div className="col-lg-3">
                        {
                            props.loading ? (
                                <Skeleton className="rounded-2" width="100%" height={40} />
                            ) : (
                                <div className="input-group">
                                    <h6 className="label">Status</h6>
                                    <Select
                                        options={Status}
                                        styles={{
                                            ...customStyle,
                                            menu: (provided) => ({
                                                ...provided,
                                                zIndex: 2,
                                            }),
                                        }}
                                        value={clientData.status}
                                        placeholder="---"
                                        onChange={(val) => {
                                            setClientData((prevVal) => ({
                                                ...prevVal,
                                                status: val,
                                            }));
                                            applyFilters({ status: val, project: clientData?.project, search: searchTerm });
                                        }}
                                        theme={(theme) => ({
                                            ...theme,
                                            colors: {
                                                ...theme.colors,
                                                primary25: '#5757fe',
                                                primary: '#5757fe',
                                            },
                                        })}
                                    />
                                </div>
                            )
                        }
                    </div>

                    <div className="col-lg-3">
                        {
                            props.loading ? (
                                <Skeleton className="rounded-2" width="100%" height={40} />
                            ) : (
                                <div className="input-group">
                                    <h6 className="label">Project</h6>
                                    <Select
                                        options={Project}
                                        styles={{
                                            ...customStyle,
                                            menu: (provided) => ({
                                                ...provided,
                                                zIndex: 2,
                                            }),
                                        }}
                                        value={clientData.project}
                                        placeholder="---"
                                        onChange={(val) => {
                                            setClientData((prevVal) => ({
                                                ...prevVal,
                                                project: val,
                                            }));
                                            applyFilters({ status: clientData?.status, project: val, search: searchTerm });
                                        }}
                                        theme={(theme) => ({
                                            ...theme,
                                            colors: {
                                                ...theme.colors,
                                                primary25: '#5757fe',
                                                primary: '#5757fe',
                                            },
                                        })}
                                    />
                                </div>
                            )
                        }
                    </div>

                    <div className="col-lg-4">
                        {
                            props.loading ? (
                                <Skeleton className="rounded-2" width="100%" height={40} />
                            ) : (
                                <div className="input-group">
                                    <h6 className="label">Search</h6>
                                    <input
                                        type="text"
                                        className="input-css"
                                        name="employeename"
                                        placeholder="Search"
                                        onChange={searchFiled}
                                    />
                                </div>
                            )
                        }
                    </div>

                    <div className="col-lg-1">


                        {/* {(initialState?.status?.value !== 'Hide Completed Task' || searchTerm || clientData?.project || clientData?.status) && ( */}
                        {shouldShowClearButton() && (
                            props.loading ? (
                                <Skeleton className="badge rounded-pill" width={100} height={40} />
                            ) : (
                                <button
                                    className="custom-taskcalendar-btn"
                                    style={{ marginTop: '34px' }}
                                    disabled={props.loading}
                                    onClick={handleClear}
                                >Clear
                                </button>
                            )
                        )}
                    </div>

                </div>

                <div className="gap-4 taskcalendar-export-btn">
                    <div></div>
                    {
                        props.loading ? (
                            <Skeleton className="rounded-2" width={50} height={40} />
                        ) : (
                            <div className="navigation_btn" style={{ marginBottom: "10px", marginTop: "10px" }}>
                                <button
                                    className={`btn1 ${activeButton === 'emptask' ? 'active' : ''}`}
                                    onClick={() => clickButton('emptask', '/task/emptask')}
                                >
                                    <TaskIcon
                                        color={activeButton === 'emptask' ? 'white' : 'black'}
                                        bgColor={activeButton === 'emptask' ? 'black' : 'white'}
                                    />
                                </button>
                                <button
                                    className={`btn1 ${activeButton === 'emptaskboard' ? 'active' : ''}`}
                                    onClick={() => clickButton('emptaskboard', '/task/emptaskboard')}
                                >
                                    <TaskBoardIcon
                                        color={activeButton === 'emptaskboard' ? 'white' : 'black'}
                                        bgColor={activeButton === 'emptaskboard' ? 'black' : 'transparent'}
                                    />
                                </button>
                                <button
                                    className={`btn1 ${activeButton === 'emptaskcalendar' ? 'active' : ''}`}
                                    onClick={() => clickButton('emptaskcalendar', '/task/emptaskcalendar')}
                                >
                                    <TaskCalendarIcon
                                        color={activeButton === 'emptaskcalendar' ? 'white' : 'black'}
                                        bgColor={activeButton === 'emptaskcalendar' ? 'black' : 'white'}
                                    />
                                </button>
                            </div>
                        )
                    }
                </div>
            </div>

            <div className="holiday-calendar">
                {
                    props.loading ? (
                        <Skeleton className="rounded-2" width="100%" height="100vh" />
                    ) : (
                        <Calendar
                            mode="month"
                            dateCellRender={dateCellRender}
                            fullscreen={true}
                        />
                    )
                }
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        loading: state.taskReducer.loading,
        task: state.taskReducer.task,
        user: state.authenticationReducer.user,
    };
};

export const mapDispatchToProps = (dispatch) => {
    return {
        getTasks: () => {
            dispatch(getTasks())
        },
        updateTask: (id, data, showToast) => {
            dispatch(updateTask(id, data, showToast))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(EmpTaskCalendar);